import styled, {css} from "styled-components";
import { Colors } from "../../../../../styles/colors";

const textAreaICP = css`
	display: flex;
	width: 100%;
	min-height:  0.5rem;
	margin-left: 30px;
	background-color: white;
	border-bottom: 1px solid ${Colors?.primary_blue_k_main+20};
	overflow-y: scroll;
	padding-top: 0rem;
	padding: 0rem;
	resize: none;
	
	::-webkit-scrollbar {
		width: 1px;
		height: 1px;
	}
	::-webkit-scrollbar-thumb {
		background: #e0e0e0;
		border-radius: 10px;
	}
	::-webkit-scrollbar-track {
		background: #ffffff;
		border-radius: 10px;
	}
`;

export const AreaText = styled.textarea<{type?: string}>`
	min-height:  22.063rem;
	min-width: 22.875rem;

	background-color: #EDEDED;

	padding: .4rem 0;

	font-family: 'NotoSans-Regular';
	font-style: normal;
	font-weight: 400;
	font-size: 1rem;
	line-height: 120%;

	border: 0;

	border-bottom: 1px solid #404040;

	color: #606060;
	
  ::placeholder,
  ::-webkit-input-placeholder {
		color: #B3B3B3;
  }
  :-ms-input-placeholder {
		color: #B3B3B3;
  }
	${({type})=> type == 'ICP' ? textAreaICP : 'undefined'}
`;

export const Area = styled.div<{type?: string}>`
	display: flex;
	align-items: flex-end;
	margin-bottom: ${({type})=> type == 'ICP' ? 20 : 0}px;
	.contador {
		margin-left: -4.5rem;
		margin-bottom: .5rem;
		color: #606060;
		${({type})=> type == 'ICP' && {
				marginBottom: '-1.5rem',
				marginLeft: '-2.5rem',
				fontSize: '0.875rem',
				color: '#797D8D', 
		}}
	}
`;